import NavigationRichMenu from './NavigationRichMenu'
export default NavigationRichMenu
